// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2hGd5","header":"PatientBlock_header__22n82","label":"PatientBlock_label__2rTnX","option":"PatientBlock_option__3-Z7U"};